// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"b9ef961d","115":"78ebd7b9","265":"4e550b53","346":"ffb7a28e","787":"3d0e97c8","889":"6e1faaef"}[chunkId] + ".chunk.js";
};